<template lang="pug">
    Tabs.newsletter-list
        el-card.contains-table(shadow="always")
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .newsletters-table(v-else)
                //- :row-link-config="newslettersPaginated.link"
                paginated-items(
                    scope="ex"
                    type="nwsltr_newsletter"
                    :loading="loading"
                    :items="newslettersPaginated.items"
                    :filters="filters"
                    :show-filters="showFilters"
                    :variables="newslettersPaginated.variables"
                    :all-columns="newslettersPaginated.allColumns"
                    :active-columns="newslettersPaginated.activeColumns"
                    :page-info="newslettersPaginated.pageInfo"
                    :sort="sort"
                    @pagination-size-change="handleSizeChange"
                    @pagination-current-change="handleCurrentChange"
                    @show-table-columns="handleColsShow"
                    @change-filter="handleFilterInputChange"
                    @change-sort="handleSortInputChange"
                    @click="handleClick"
                )
                    template(v-slot:actions="{ item }")
                        el-tooltip(
                            :content="$t('Duplicate newsletter')"
                            placement="top"
                        )
                            el-button.duplicate-button(
                                plain
                                circle
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-copy fas"
                                @click.stop.prevent="duplicateNewsletter(item)"
                            )
                        el-tooltip(
                            v-if="item.template"
                            :content="$t('Preview template')"
                            placement="top"
                        )
                            el-button.preview-button(
                                plain
                                circle
                                size="mini"
                                type="info"
                                icon="el-icon-fa-eye fas"
                                @click.stop.prevent="openTemplatePreview(item)"
                            )
                    template(v-slot:status="{ value }")
                        span {{ $t(value) }}
                    template(slot="top")
                        el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                            .left
                                el-button(type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addNewsletter")
                                    | {{ $t('New Newsletter') }}
                            .right.hide-on-empty
                                el-button(
                                    plain
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-fa-filter fas"
                                    @click="toggleFilterVisiblity"
                                    :disabled="disable.showFilters || hasFilters"
                                )
                                    span(v-if="showFilters") {{ $t('Hide filters') }}
                                    span(v-else) {{ $t('Show filters') }}

        //- Template Preview Drawer
        el-drawer.template-preview-drawer(
            :title="previewNewsletter ? previewNewsletter.subject : $t('Template Preview')"
            :visible.sync="showTemplatePreview"
            direction="rtl"
            size="40%"
            :before-close="closeTemplatePreview"
        )
            .drawer-content(v-if="previewNewsletter")
                iframe(
                    ref="templatePreview"
                    frameBorder="0"
                    @load="adjustIframeHeight"
                )
</template>

<i18n>
{
    "en": {
        "pos-template": "POS Template",
        "Duplicate newsletter": "Duplicate newsletter"
    },
    "de": {
        "New Newsletter": "Neuer Newsletter",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Newsletter list could not be fetched.": "Newsletterliste konnte nicht abgerufen werden.",
        "Newsletter duplicated successfully": "Newsletter erfolgreich dupliziert",
        "Failed to duplicate newsletter": "Newsletter konnte nicht dupliziert werden",
        "Duplicate newsletter": "Newsletter duplizieren",
        "An error occurred": "Ein Fehler ist aufgetreten",
        "Preview template": "Vorlage anzeigen",
        "Template Preview": "Vorlagen-Vorschau",
        "draft": "Entwurf",
        "planned": "Geplant",
        "sending": "Wird gesendet",
        "sent": "Gesendet",
        "pos-template": "POS-Vorlage"
    }
}
</i18n>

<script>
import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo'

import router from '@/router'
import pinia from '@/pinia';
import { useSetupStore, useNewsletterNewsletterStore } from '@/stores'
import gql from 'graphql-tag'

import PaginatedItems from '@/components/PaginatedItems'
import Tabs from '@/views/cms/Marketing/Partials/Tabs'
import Error from '@/components/Error'

export default {
    name: 'Newsletters',
    data() {
        return {
            // loading: true,
            error: false,
            disable: {
                showFilters: false,
            },
            showTemplatePreview: false,
            previewNewsletter: null,
        }
    },
    components: {
        PaginatedItems,
        Error,
        Tabs
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true)
            if (reload) this.initialize()
        },
    },
    computed: {
        showFilters() {
            return this.hasFilters || _.get(this.newslettersPaginated, 'showFilters') || false
        },
        hasFilters() {
            return ! _.isEmpty(this.filters)
        },
        filters() {
            let filters = _.cloneDeep(this.newslettersPaginated.filters)
            delete filters.cms
            return filters
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        debounce() {
            return useSetupStore().debounce;
        },
        newsletterStore() {
            return useNewsletterNewsletterStore();
        },
        loading() {
            return this.newsletterStore.loading;
        },
        newslettersPaginated() {
            return this.newsletterStore.newslettersPaginated;
        },
        sort() {
            var variables = this.newslettersPaginated.variables;
            var defaultSort = this.newslettersPaginated.defaultSort || { field: 'created_at', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        setupStore() {
            return useSetupStore();
        }
    },
    methods: {
        initialize() {
            if (! this.enabledExtensions.includes('newsletter')) {
                this.newsletterStore.updateLoading(true)
                // this.$router.push({ name: 'newsletter' })

                return
            }

            this.newsletterStore.updateLoading(true)
            this.refetch()
        },
        getCurrency(item) {
            return _.get(item, 'currency')
        },
        addNewsletter() {
            // TODO
            // open stepper modal

            const params = { id: 'new' }
            router.push({ name: 'newsletter-main', params })
        },
        handleClick(item) {
            const params = { id: item.id }
            router.push({ name: 'newsletter-main', params })
        },
        handleSizeChange(itemsPerPage) {
            this.newsletterStore.updateLoading(true)
            this.newsletterStore.defineItemsPerPage(itemsPerPage)
            this.refetch()
        },
        handleCurrentChange (currentPage) {
            this.newsletterStore.updateLoading(true)
            this.newsletterStore.defineCurrentPage(currentPage)
            this.refetch()
        },
        handleColsShow(visibleColumns) {
            this.newsletterStore.defineActiveColumns(visibleColumns)
            // apolloClient.cache.reset()
            apolloClient.clearStore()
        },
        handleFilterInputChange(key, value, debounce = true) {
            this.newsletterStore.defineFilterValue({ key, value })
            if (debounce) this.debouncedRefetch()
            else this.refetch()
        },
        handleSortInputChange(key, value) {
            this.newsletterStore.defineSorting({ key, value })
            this.refetch()
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters

            let value = false
            if (! visible) value = true

            this.disable.showFilters = true
            this.newsletterStore.defineFilterVisibility(value)
            this.saveFilterVisibility({ scope: 'ex', key: 'nwsltr_newsletter', value })
                .finally(() => this.disable.showFilters = false)
        },
        refetch() {

            // always add the cms id to filters
            const cmsID = this.activeCms.id
            const filter = {
                key: 'cms',
                match: cmsID,
            }
            this.newsletterStore.defineFilterValue({ key: 'cms', value: filter })

            this.newsletterStore.fetchNewslettersPaginated()
                .then(() => this.newsletterStore.updateLoading(false))
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Newsletter list could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.newsletterStore.updateLoading(false);

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                })
        },
        debouncedRefetch: _.debounce(function() { // function scope is needed here
            this.newsletterStore.updateLoading(true)
            this.refetch()
        }, useSetupStore(pinia).debounce || 300),
        openTemplatePreview(item) {
            this.previewNewsletter = item
            this.showTemplatePreview = true
            this.$nextTick(() => {
                this.loadPreviewContent()
            })
        },
        closeTemplatePreview() {
            this.showTemplatePreview = false
            this.previewNewsletter = null
        },
        loadPreviewContent() {
            const iframe = this.$refs.templatePreview
            if (!iframe) return

            const template = _.get(this.previewNewsletter, 'template', '')
            if (!template) return

            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
            iframeDoc.open()
            iframeDoc.write(template)
            iframeDoc.close()
        },
        adjustIframeHeight() {
            const iframe = this.$refs.templatePreview
            if (iframe && iframe.contentDocument) {
                const height = iframe.contentDocument.body.scrollHeight
                iframe.style.height = Math.max(height + 20, 400) + 'px'
            }
        },
        async duplicateNewsletter(item) {
            // Show loading
            this.newsletterStore.updateLoading(true)

            try {
                const DUPLICATE_NEWSLETTER = gql`
                    mutation DuplicateNewsletter($id: Int!) {
                        EX_NWSLTR_DuplicateNewsletter(id: $id) {
                            id
                            subject
                        }
                    }
                `

                const response = await apolloClient.mutate({
                    mutation: DUPLICATE_NEWSLETTER,
                    variables: { id: parseInt(item.id, 10) }
                })

                if (response.data && response.data.EX_NWSLTR_DuplicateNewsletter) {
                    const duplicated = response.data.EX_NWSLTR_DuplicateNewsletter

                    // Show success notification
                    this.$notify.success({
                        title: this.$t('Newsletter duplicated successfully'),
                        message: duplicated.subject,
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 5000
                    })

                    // Clear Apollo cache and refresh the list to show the new duplicate
                    await apolloClient.clearStore()
                    this.refetch()
                }
            } catch (error) {
                // Show error notification
                this.$notify.error({
                    title: this.$t('Failed to duplicate newsletter'),
                    message: error.message || this.$t('An error occurred'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                })

                /* eslint no-console: ["error", { allow: ["error"] }] */
                console.error('Failed to duplicate newsletter:', error)

                this.newsletterStore.updateLoading(false)
            }
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
    },
    mounted() {
        this.initialize()
    },
}
</script>

<style lang="sass" scoped>
.error
    padding: 20px

.preview-button
    margin-right: 0.5rem

.duplicate-button
    margin-right: 0.5rem

.template-preview-drawer
    ::v-deep .el-drawer
        min-width: 600px
        max-width: 90%

    .drawer-content
        height: 100%
        // padding: 0 20px 20px

        iframe
            width: 100%
            min-height: 100%
            border: none
            background: white
</style>
